import { dateTimeFormatter } from "@talladega/helpers";
import { convert, LocalDateTime } from "@js-joda/core";
import { useRef } from "react";
import { Listbox, ListboxProps } from "../Listbox";

export type TimeSlot = {
  id: number;
  name: string;
};

type Props = {
  locale?: string;
  filter?: (time: number) => boolean;
  placeholder?: string;
} & Omit<
  ListboxProps<TimeSlot>,
  "items" | "keyOption" | "displayOption" | "displayButton" | "valueOption"
>;

const getTimeSlots = (
  locale: string,
  filter: (time: number) => boolean
): TimeSlot[] => {
  const today = LocalDateTime.now();
  const timeSlots = [...Array(24)].map((a, i) => {
    const fromTime = today.withHour(i).withMinute(0);
    const toTime = fromTime.plusHours(1);
    const jsFromTime = convert(fromTime).toDate();
    const jsToTime = convert(toTime).toDate();

    return {
      id: i,
      name: `${dateTimeFormatter(
        jsFromTime,
        locale,
        "h:mm aa"
      )} - ${dateTimeFormatter(jsToTime, locale, "h:mm aa")}`,
    };
  });

  return timeSlots.filter(({ id }) => filter(id));
};

export const TimeSlotListbox = ({
  locale = "en",
  filter = () => true,
  onChange,
  placeholder,
  ...props
}: Props) => {
  const timeSlotsRef = useRef(getTimeSlots(locale || "en", filter));

  return (
    <Listbox
      items={timeSlotsRef.current}
      keyOption={(item) => item.id}
      displayOption={(item) => item?.name || ""}
      displayButton={(item) => item?.name || placeholder || ""}
      valueOption={(item) => item}
      onChange={onChange}
      {...props}
    />
  );
};
